<div class="footer mt-5">
	<cfe-scroll-top></cfe-scroll-top>
	<div class="container-fluid">
		<div class="d-flex">
			<div *ngIf="config?.versionInfo && config?.versionInfoShown" class="version-info">
				<span>{{ 'version' | translate }}</span> {{ config.versionInfo }}
			</div>
			<div class="link ml-4">
				<a [routerLink]="['/external/status']" target="_blank">{{ 'state.title' | translate }}</a>
			</div>
			<div *ngIf="config?.hostedInChinaCloud && config?.icpText && config?.icpLink" class="link ml-auto">
				<a href="{{ config?.icpLink }}" target="_blank">{{ config?.icpText }}</a>
			</div>
		</div>
		<div class="footer-container">
			<div class="row">
				<div class="col-lg-8 col-md-9 col-sm-12 sm-mb-1">
					<ul class="link-list list-inline mb-md-0">
						<li class="list-inline-item">© {{ year }} Dentsply Sirona. All rights reserved.</li>
						<li class="list-inline-item">
							<a href="{{ privacyLink }}" target="_blank">{{ 'footer.link.privacyPolicy' | translate }}</a>
						</li>
						<li class="list-inline-item">
							<a href="{{ termsOfUse }}" target="_blank">{{ 'footer.link.termsOfUse' | translate }}</a>
						</li>
						<li class="list-inline-item" *ngIf="imprintLink">
							<a href="{{ imprintLink }}" target="_blank">{{ 'footer.link.imprint' | translate }}</a>
						</li>
						<li class="list-inline-item">
							<a href="{{ complianceAndEthics }}" target="_blank">{{ 'footer.link.complianceAndEthics' | translate }}</a>
						</li>
						<li class="list-inline-item" *ngIf="dentsplySironaInc">
							<a href="{{ dentsplySironaInc }}" target="_blank">{{ 'footer.link.dentsplySironaInc' | translate }}</a>
						</li>
						<li class="list-inline-item" *ngIf="termsAndConditions">
							<a href="{{ termsAndConditions }}" target="_blank">{{ 'footer.link.termsAndConditions' | translate }}</a>
						</li>
					</ul>
				</div>
				<div *ngIf="!config?.hostedInChinaCloud" class="col-lg-4 col-md-3 col-sm-12 text-center text-md-right">
					<ul class="list-inline social-links mb-0">
						<li class="list-inline-item">
							<a href="{{ twitterLink }}" target="_blank"><i class="cfe cfe-twitter"></i></a>
						</li>
						<li class="list-inline-item">
							<a href="{{ facebookLink }}" target="_blank"><i class="cfe cfe-facebook"></i></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
